import React, { useCallback } from 'react'
import {
  PAGE_URL_CATALOG,
  PAGE_URL_ACTIVE,
  PAGE_URL_CART,
  PAGE_URL_HISTORY,
  PAGE_URL_PROFILE,
} from 'SiteURLs'

interface ITopNavLinksAuthProps {
  currentHash: string
  onLogout: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

const TopNavLinksAuth: React.FC<ITopNavLinksAuthProps> = ({ currentHash, onLogout }) => {
  const getNavClass = useCallback(
    (href) => {
      if (currentHash === href) return 'nav-link topmenu-link active'
      else return 'nav-link topmenu-link'
    },
    [currentHash]
  )
  return (
    <>
      <a className={getNavClass('#/' + PAGE_URL_CATALOG)} href={'#/' + PAGE_URL_CATALOG}>
        Каталог
      </a>
      <a className={getNavClass('#/' + PAGE_URL_ACTIVE)} href={'#/' + PAGE_URL_ACTIVE}>
        Заказы
      </a>
      <a className={getNavClass('#/' + PAGE_URL_CART)} href={'#/' + PAGE_URL_CART}>
        Корзина
      </a>
      <a className={getNavClass('#/' + PAGE_URL_HISTORY)} href={'#/' + PAGE_URL_HISTORY}>
        История
      </a>
      <a className={getNavClass('#/' + PAGE_URL_PROFILE)} href={'#/' + PAGE_URL_PROFILE}>
        Профиль
      </a>
      <a className='nav-link topmenu-link' href={'#/'} onClick={onLogout}>
        Выход
      </a>
    </>
  )
}
export default TopNavLinksAuth
